/**
 * @flow
 * @relayHash 0bbf38bdba508f043cb83f4ee014af66
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type VipAccountManagerLinkRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query VipAccountManagerLinkRefetchQuery(
  $userIds: [String]!
  $fetchRep: Boolean!
) {
  viewer {
    ...VipAccountManagerLink_viewer_1EqXkF
    id
  }
}

fragment VipAccountManagerLink_viewer_1EqXkF on Viewer {
  userRelationships(userIds: $userIds, relationshipType: VIP) @include(if: $fetchRep) {
    userDataB {
      __typename
      ... on VipRepData {
        displayName
        phoneNumber(formatType: INTERNATIONAL)
        email
      }
    }
    id
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchRep",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VipAccountManagerLinkRefetchQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "VipAccountManagerLink_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "fetchRep",
                "variableName": "fetchRep",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "VipAccountManagerLinkRefetchQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String]!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchRep",
        "type": "Boolean!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "VipAccountManagerLinkRefetchQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRep",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "relationshipType",
                    "value": "VIP",
                    "type": "relationshipType!"
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds",
                    "type": "[String]!"
                  }
                ],
                "concreteType": "UserRelationship",
                "name": "userRelationships",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "name": "userDataB",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "VipRepData",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "formatType",
                                "value": "INTERNATIONAL",
                                "type": "formatPhoneNumberTypes"
                              }
                            ],
                            "name": "phoneNumber",
                            "storageKey": "phoneNumber{\"formatType\":\"INTERNATIONAL\"}"
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "email",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query VipAccountManagerLinkRefetchQuery(\n  $userIds: [String]!\n  $fetchRep: Boolean!\n) {\n  viewer {\n    ...VipAccountManagerLink_viewer_1EqXkF\n    id\n  }\n}\n\nfragment VipAccountManagerLink_viewer_1EqXkF on Viewer {\n  userRelationships(userIds: $userIds, relationshipType: VIP) @include(if: $fetchRep) {\n    userDataB {\n      __typename\n      ... on VipRepData {\n        displayName\n        phoneNumber(formatType: INTERNATIONAL)\n        email\n      }\n    }\n    id\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/VipAccountManagerLink/__generated__/VipAccountManagerLinkRefetchQuery.graphql.js